import { render, staticRenderFns } from "./TeamFields.vue?vue&type=template&id=489546bc&"
import script from "./TeamFields.vue?vue&type=script&lang=js&"
export * from "./TeamFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports